import { isEmpty } from "lodash";
import { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { ISidebarState, useSidebarState } from "../../store/sidebarState";
import { IUserStoreState, useUserStore } from "../../store/userState";
import AssetReportTable from "./assetReportsTable";
import AssetReportWithoutRunTable from "./assetReportsWithoutRun";
import TabGenerator from "../settings/TabGenerator";
import IssueReport from "./issuesReport";
import UsersTable from "./usersReport";
import InvitesTable from "./invitesReport";
import { Typography } from "@mui/material";
import { Box } from "@mui/system";

const Reports = () => {
  const [activeTab, setActiveTab] = useState("assetReport");
  const { fetchContext, context } = useSidebarState(
    (state) => state
  ) as ISidebarState;
  useEffect(() => {
    if (isEmpty(context)) {
      fetchContext();
    }
  }, [context]);
  const tabs = [
    {
      label: "Assets",
      value: "assetReport",
      component: <AssetReportWithoutRunTable />,
    },
    {
      label: "Runs",
      value: "runsReport",
      component: <AssetReportTable />,
    },
    {
      label: "Issues",
      value: "issuesReport",
      component: <IssueReport />,
    },
    {
      label: "Users",
      value: "usersReport",
      component: <UsersTable />,
    },
    {
      label: "Invites",
      value: "invitesReport",
      component: <InvitesTable />,
    },
  ];

  return (
    <>
    <Box sx={{textAlign: "left", pl: 2, pt: 1}}>
      <Typography color="textPrimary" sx={{textAlign: "left"}} variant="h4">Reports</Typography>
    </Box>
      <TabGenerator tabs={tabs} activeTab={activeTab} />
    </>
  );
};


export default withRouter(Reports);